import React from 'react'
import { useLocation } from 'react-router-dom'
import StatsAndStandingsHomeNavigation from './StatsAndStandingsHomeNavigation'
import SelectLeague from '../UIElements/SelectLeague'
import Footer from '../UIElements/Footer'
import SearchForPlayer from '../UIElements/SearchForPlayer'
import './StatsAndStandingsHome.css'

const StatsAndStandingsHome = () => {
	console.log('inside StatsAndStandingsHome')
	const location = useLocation()

	// true ONLY when URL ends with /history
	const showSearchForPlayer = location.pathname.endsWith('/history')
	return (
		<div style={{ overflowX: 'hidden' }}>
			<StatsAndStandingsHomeNavigation />
			<SelectLeague />
			{showSearchForPlayer && <SearchForPlayer />}
			{/* <div className='rem'>
				<Footer />
			</div> */}
		</div>
	)
}

export default StatsAndStandingsHome
